import React from 'react'

import { getLabelFromStorage, isHmBrand, currentBrand, isNorthstarBrand } from '@pb/utils'
import { Helmet } from 'react-helmet'
import { useLocation } from 'react-router-dom'

import getTitleLabels from './helpers/getTitleLabels'

const separator = ' - '

const Title: React.FC = () => {
  const currentLocation = useLocation()

  const hmTitle = getLabelFromStorage('general.hm')
  const brandTitle = currentBrand?.toUpperCase()

  const { titles } = getTitleLabels(currentLocation.pathname)
  const translatedTitles = titles.map((title) => getLabelFromStorage(title))
  const jointTitles = translatedTitles.join(separator)

  return (
    <Helmet
      defaultTitle={isHmBrand || isNorthstarBrand ? hmTitle : brandTitle}
      titleTemplate={`%s${separator}${isHmBrand || isNorthstarBrand ? hmTitle : brandTitle}`}
    >
      <title>{jointTitles}</title>
    </Helmet>
  )
}

export default Title
